import classNames from 'classnames'

import styles from './Progress.pcss'

interface Props {
	increase?: number
	max: number
	step: number
	value: number
}

export function Progress({ increase, max, step, value }: Props) {
	let steps = []
	if (step) {
		const stepsCount = max / step
		steps.push(1)
		for (let index = 1; index < stepsCount + 1; ++index) {
			steps.push(step * index)
		}
	}

	const progressWidth = (value / max) * 100
	const increaseWidth = increase && (increase / max) * 100

	return (
		<div className={styles.container}>
			<div className={styles.progress}>
				<div
					className={classNames(styles.value, styles.current)}
					style={{ width: `${progressWidth}%` }}
				/>
				{!!increaseWidth && (
					<div
						className={classNames(styles.value, styles.increase)}
						style={{ width: `${increaseWidth}%` }}
					/>
				)}
			</div>
			<div className={styles.steps}>
				{steps.map((item) => (
					<div className={styles.step} key={item}>
						<span className={styles.stepValue}>{item}</span>
					</div>
				))}
			</div>
		</div>
	)
}
